import { System } from './../System';

import { Observable, of, ReplaySubject} from 'rxjs';
import {EventEmitter, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GeneralPreferences } from './general-preferences.model';
import { AttendancePreferences } from './attendance-preferences.model';
import { ClassroomSummaryPreferences } from './classroom-summary-preferences.model';
import { CommunicationLogPreferences } from './communication-log-preferences.model';
import { DataQueryPreferences } from './data-query-preferences.model';
import { MassEmailPreferences } from './mass-email-preferences.model';
import { GradebookPreferences } from '../../classroom360/gradebook/shared/models/preferences/gradebook-preferences.model';
import { ClassroomSummary } from '../../classroom360/classroom-summary/models/classroom-summary.model';
import { Year } from '../year/year.model';
import { Subscription } from '../../../../node_modules/rxjs';
import { YearService } from '../year/year.service';
import { Subject } from '../../../../node_modules/rxjs';
import { FavoritePreferences } from './favorite-prefences.model';
import { PortalMenuPreferences } from './portal-menu-preferences.model';
import { Portal } from '../portal.model';
import { UserService } from '../user/user.service';
import { GradebookSelectionPreferences } from './gradebook-selection-preferences.model';
import {map} from 'rxjs/operators';
import { BehaviorPreferences } from './behavior-preferences.model';
import {MasterSchedulePreferences} from './master-schedule-preferences.model';
import {PeriodStatisticsPreferences} from './period-statistics-preferences.model';
import { GradebookAnalysisSetting } from './gradebook-analysis-setting.model';
import {ScheduleStudentListPreferences} from './schedule-student-list-preferences.model';
import {ClassesByCoursePreferences} from './classes-by-course-preferences.model';
import {ClassRosterPreferences} from './class-roster-preferences.model';
import {RoomSchedulingSettingsPreferences} from './room-scheduling-settings-preferences.model';

@Injectable()
export class UserPreferencesService {
    // General preferences
    private _generalPreferences: GeneralPreferences;
    public get generalPreferences(): GeneralPreferences {
        return this._generalPreferences;
    }

    public set generalPreferences(value: GeneralPreferences) {
        this._generalPreferences = value;
        this.observablegeneralPreferences.next(value);
    }

    public observablegeneralPreferences = new Subject<GeneralPreferences>();
    observablegeneralPreferencesStream$ = this.observablegeneralPreferences.asObservable();

    // Attendance preferences
    private _attendancePreferences: AttendancePreferences;
    public get attendancePreferences(): AttendancePreferences {
        return this._attendancePreferences;
    }

    public set attendancePreferences(value: AttendancePreferences) {
        this._attendancePreferences = value;
        this.observableAttendancePreferences.next(value);
    }

    public observableAttendancePreferences = new Subject<AttendancePreferences>();
    observableAttendancePreferencesStream$ = this.observableAttendancePreferences.asObservable();

    // ClassroomSummary preferences
    private _classroomSummaryPreferences: ClassroomSummaryPreferences;
    public get classroomSummaryPreferences(): ClassroomSummaryPreferences {
        return this._classroomSummaryPreferences;
    }

    public set classroomSummaryPreferences(value: ClassroomSummaryPreferences) {
        this._classroomSummaryPreferences = value;
        this.observableClassroomSummaryPreferences.next(value);
    }

    public observableClassroomSummaryPreferences = new Subject<ClassroomSummaryPreferences>();
    observableclassroomSummaryPreferencesStream$ = this.observableClassroomSummaryPreferences.asObservable();

    // CommunicationLog preferences
    private _communicationLogPreferences: CommunicationLogPreferences;
    public get communicationLogPreferences(): CommunicationLogPreferences {
        return this._communicationLogPreferences;
    }

    public set communicationLogPreferences(value: CommunicationLogPreferences) {
        this._communicationLogPreferences = value;
        this.observableCommunicationLogPreferences.next(value);
    }

    public observableCommunicationLogPreferences = new Subject<CommunicationLogPreferences>();
    observableCommunicationLogPreferencesStream$ = this.observableCommunicationLogPreferences.asObservable();

    // DataQuery preferences
    private _dataQueryPreferences: DataQueryPreferences;
    public get dataQueryPreferences(): DataQueryPreferences {
        return this._dataQueryPreferences;
    }

    public set dataQueryPreferences(value: DataQueryPreferences) {
        this._dataQueryPreferences = value;
        this.observableDataQueryPreferences.next(value);
    }
	public dataQueryPreferenceChange = new EventEmitter<any>();
    public observableDataQueryPreferences = new Subject<DataQueryPreferences>();
    observableDataQueryPreferencesStream$ = this.observableDataQueryPreferences.asObservable();

    // MassEmail preferences
    private _massEmailPreferences: MassEmailPreferences;
    public get massEmailPreferences(): MassEmailPreferences {
        return this._massEmailPreferences;
    }

    public set massEmailPreferences(value: MassEmailPreferences) {
        this._massEmailPreferences = value;
        this.observableMassEmailPreferences.next(value);
    }

    public observableMassEmailPreferences = new Subject<MassEmailPreferences>();
    observableMassEmailPreferencesStream$ = this.observableMassEmailPreferences.asObservable();

    // Gradebook preferences
    private _gradebookPreferences: GradebookPreferences;
    public get gradebookPreferences(): GradebookPreferences {
        return this._gradebookPreferences;
    }

    public set gradebookPreferences(value: GradebookPreferences) {
        this._gradebookPreferences = value;
    }

    public observableGradebookPreferences = new Subject<GradebookPreferences>();
    observableGradebookPreferencesStream$ = this.observableGradebookPreferences.asObservable();

    // Favorites preferences
    private _favoritesPreferences: FavoritePreferences;
    public get favoritesPreferences(): FavoritePreferences {
        return this._favoritesPreferences;
    }

    public set favoritesPreferences(value: FavoritePreferences) {
        this._favoritesPreferences = value;
        this.observableFavoritesPreferences.next(value);
    }

    public observableFavoritesPreferences = new Subject<FavoritePreferences>();
    observableFavoritesPreferencesStream$ = this.observableFavoritesPreferences.asObservable();

    // Behavior preferences
    private _behaviorPreferences: BehaviorPreferences;
    public get behaviorPreferences(): BehaviorPreferences {
        return this._behaviorPreferences;
    }

    public set behaviorPreferences(value: BehaviorPreferences) {
        this._behaviorPreferences = value;
        this.observableBehaviorPreferences.next(value);
    }

    public observableBehaviorPreferences = new Subject<BehaviorPreferences>();
    observableBehaviorPreferencesStream$ = this.observableBehaviorPreferences.asObservable();

    // Portal Menu Preferences
    private studentId = -1;
    private _studentPortalMenuPreferences: PortalMenuPreferences;
    public get studentPortalMenuPreferences(): PortalMenuPreferences {
        return this._studentPortalMenuPreferences;
    }

    public set studentPortalMenuPreferences(value: PortalMenuPreferences) {
        this._studentPortalMenuPreferences = value;
        this.observableStudentPortalMenuPreferences.next(value);
    }

    public observableStudentPortalMenuPreferences = new Subject<PortalMenuPreferences>();
    observableStudentPortalMenuPreferencesStream$ = this.observableStudentPortalMenuPreferences.asObservable();

    private _staffPortalMenuPreferences: PortalMenuPreferences;
    public get staffPortalMenuPreferences(): PortalMenuPreferences {
        return this._staffPortalMenuPreferences;
    }

    public observableStaffPortalMenuPreferences = new Subject<PortalMenuPreferences>();
    observableStaffPortalMenuPreferencesStream$ = this.observableStaffPortalMenuPreferences.asObservable();

    // Master Schedule Preferences
    private _masterSchedulePreferences: MasterSchedulePreferences;
    public get masterSchedulePreferences(): MasterSchedulePreferences {
        return this._masterSchedulePreferences;
    }
    public set masterSchedulePreferences(value: MasterSchedulePreferences) {
        this._masterSchedulePreferences = value;
        this.observableMasterSchedulePreferences.next(value);
    }
    private observableMasterSchedulePreferences = new Subject<MasterSchedulePreferences>();
    observableMasterSchedulePreferencesStream$ = this.observableMasterSchedulePreferences.asObservable();

    // Class Roster Preferences
    private _classRosterPreferences: ClassRosterPreferences;
    public get classRosterPreferences(): ClassRosterPreferences {
        return this._classRosterPreferences;
    }
    public set classRosterPreferences(value: ClassRosterPreferences) {
        this._classRosterPreferences = value;
        this.observableClassRosterPreferences.next(value);
    }
    private observableClassRosterPreferences = new Subject<ClassRosterPreferences>();
    observableClassRosterPreferencesStream$ = this.observableClassRosterPreferences.asObservable();

    // Period Statistics Preferences
    private _periodStatisticsPreferences: PeriodStatisticsPreferences;
    public get periodStatisticsPreferences(): PeriodStatisticsPreferences {
        return this._periodStatisticsPreferences;
    }
    public set periodStatisticsPreferences(value: PeriodStatisticsPreferences) {
        this._periodStatisticsPreferences = value;
        this.observablePeriodStatisticsPreferences.next(value);
    }
    private observablePeriodStatisticsPreferences = new Subject<PeriodStatisticsPreferences>();
    observablePeriodStatisticsPreferencesStream$ = this.observablePeriodStatisticsPreferences.asObservable();

    // Schedule Student List Preferences
    private _scheduleStudentListPreferences: ScheduleStudentListPreferences;
    public get scheduleStudentListPreferences(): ScheduleStudentListPreferences {
        return this._scheduleStudentListPreferences;
    }
    public set scheduleStudentListPreferences(value: ScheduleStudentListPreferences) {
        this._scheduleStudentListPreferences = System.convert(value, new ScheduleStudentListPreferences());
        this.observableScheduleStudentListPreferences.next(value);
    }
    private observableScheduleStudentListPreferences = new Subject<ScheduleStudentListPreferences>();
    observableScheduleStudentListPreferencesStream$ = this.observableScheduleStudentListPreferences.asObservable();

    // Classes By Course Preferences
    private _classesByCoursePreferences: ClassesByCoursePreferences;
    public get classesByCoursePreferences(): ClassesByCoursePreferences {
        return this._classesByCoursePreferences;
    }
    public set classesByCoursePreferences(value: ClassesByCoursePreferences) {
        this._classesByCoursePreferences = value;
        this.observableClassesByCoursePreferences.next(value);
    }
    private observableClassesByCoursePreferences = new Subject<ClassesByCoursePreferences>();
    observableClassesByCoursePreferencesStream$ = this.observableClassesByCoursePreferences.asObservable();

    // Room Scheduling Settings Preferences
    private _roomSchedulingSettingsPreferences: RoomSchedulingSettingsPreferences;
    public get roomSchedulingSettingsPreferences(): RoomSchedulingSettingsPreferences {
        return this._roomSchedulingSettingsPreferences;
    }
    public set roomSchedulingSettingsPreferences(value: RoomSchedulingSettingsPreferences) {
        this._roomSchedulingSettingsPreferences = System.convert(value, new RoomSchedulingSettingsPreferences());
        this.observableRoomSchedulingSettingsPreferences.next(value);
    }
    private observableRoomSchedulingSettingsPreferences = new ReplaySubject<RoomSchedulingSettingsPreferences>(1);
    observableRoomSchedulingSettingsPreferencesStream$ = this.observableRoomSchedulingSettingsPreferences.asObservable();

    defaultYear: Year;
    defaultYearSubscription: Subscription;
    courseId: any;
    siteSubjectListId: any;
    section: any;
    showAssignmentsonStandards: boolean;
    editFavorites = false;
    warnIfCalculationPreferencesChanged = false;
    gradebookV9SelectionPreferences: GradebookSelectionPreferences;
    gradebookV9AnalysisSettings: GradebookAnalysisSetting;

    constructor(
        private http: HttpClient,
        private yearService: YearService,
        private userService: UserService
    ) {
        this.defaultYear = this.yearService.defaultYear;
        this.defaultYearSubscription = yearService.observableDefaultYearStream$.subscribe(
            defaultYear => {
                this.defaultYear = defaultYear;
            }
        );
    }

    getUserPreferences(studentId: number, pageUrl: string, subjectListId: number = 0, subjectSection: string = '', isDefaultPreferences: boolean = false): Observable<any> {
        let paramString = '';
        paramString += '?studentId=' + studentId;
        paramString += '&pageURL=' + pageUrl;
        paramString += '&subjectListId=' + subjectListId;
        paramString += '&subjectSection=' + subjectSection;
        paramString += '&isDefaultPreferences=' + isDefaultPreferences;
        return this.http.get<any>(System.apiURL.Student + 'GetUserPreferences' + paramString);
    }

    saveUserPreferences(studentId: number, pageUrl: string, data: any, subjectListId: number, subjectSection: string, isDefaultPreferences: boolean = false): Observable<any> {
        let paramString = '';
        paramString += '?studentId=' + studentId;
        paramString += '&pageURL=' + pageUrl;
        paramString += '&subjectListId=' + subjectListId;
        paramString += '&subjectSection=' + subjectSection;
        paramString += '&isDefaultPreferences=' + isDefaultPreferences;
        return this.http.post<void>(System.apiURL.Student + 'SaveUserPreferences' + paramString, data).pipe(
        	map(results => {
        		if (pageUrl.toLowerCase().includes('dataquery')) {
					this.dataQueryPreferenceChange.emit();
				}
        		return results;
			})
		);
    }

    getGeneralPreferences(): Observable<GeneralPreferences> {
        if (this.generalPreferences) {
            return of(this.generalPreferences);
        } else {
            return this.getUserPreferences(0, '/OneSISGeneralPreferences', 0, '', false).pipe(
                map(results => {
                    this.generalPreferences = JSON.parse(results[0]);
                    return this.generalPreferences;
                })
            );
        }
    }

    getGradebookPreferences(course: ClassroomSummary): Observable<any> {
        return this.http.get(System.apiURL.Student + 'GetUserPreferences?studentId=0&pageURL=/OneSISGradeBook&subjectListId=' + course.Id + '&subjectSection=\'\'&isDefaultPreferences=false');
    }

    updateGradebookPReferences() {
        this.observableGradebookPreferences.next();
    }

    getAttendancePreferences(): Observable<any> {
        return this.getUserPreferences(0, '/OneSISAttendance');
    }

    getWarnIfCalculationPreferencesChanged(courseId: number, syncPreference: boolean): Observable<boolean> {
        let paramString = '';
        paramString += '?tgsId=' + courseId;
        paramString += '&syncPreferences=' + syncPreference;
        return this.http.get<boolean>(System.apiURL.Student + 'WarnIfCalculationPreferencesChanged' + paramString);
    }

    saveAttendancePreferences() {
        this.saveUserPreferences(0, '/OneSISAttendance', this.attendancePreferences, 0, '');
    }

    getMyClasses(termId: number, viewId: number, isTeacher: boolean, includeAllCourses: boolean, dateItem: Date): Observable<ClassroomSummary[]> {
        const currentDate = new Date();
        const dateString = (currentDate.getUTCMonth() + 1) + '/' + currentDate.getDate() + '/' + currentDate.getUTCFullYear();
        let queryString = '';
        queryString += '?schoolId=' + this.yearService.defaultYear.SchoolID +
            '&yearId=' + this.yearService.defaultYear.Id +
            '&termId=' + termId +
            '&viewId=' + viewId +
            '&isTeacher=' + isTeacher +
            '&dateItem=' + dateItem +
            '&includeAllCourses=' + includeAllCourses +
            '&currentDate=' + dateString;
        return this.http.get<ClassroomSummary[]>
            (System.apiURL.Classroom + 'GetMyClasses' + queryString);
    }

	public set staffPortalMenuPreferences(value: PortalMenuPreferences) {
		this._staffPortalMenuPreferences = value;
		this.observableStaffPortalMenuPreferences.next(value);
	}

	getStaffMenuPreferences() {
		if (this.staffPortalMenuPreferences) {
			return of(this.staffPortalMenuPreferences);
		} else {
			return this.getUserPreferences(0, '/OneSISPortalMenuPreferences');
		}
	}

	getStudentMenuPreferences(studentId: number) {
		if (this.studentPortalMenuPreferences && studentId == this.studentId) {
			return of(this.studentPortalMenuPreferences);
		} else {
			this.studentId = studentId;
			return this.getUserPreferences(studentId, '/OneSISPortalMenuPreferences');
		}
	}

    getMasterSchedulePreferences() {
        if (this.masterSchedulePreferences) {
            return of(this.masterSchedulePreferences);
        } else {
            return this.getUserPreferences(0, '/OneSISMasterSchedule');
        }
    }

    getPeriodStatisticsPreferences() {
        if (this.periodStatisticsPreferences) {
            return of(this.periodStatisticsPreferences);
        } else {
            return this.getUserPreferences(0, '/OneSISPeriodStatistics').pipe(
                map(json => {
                    return JSON.parse(json[0]) as PeriodStatisticsPreferences;
                })
            );
        }
    }

    getScheduleStudentListPreferences() {
        if (this.scheduleStudentListPreferences) {
            return of(this.scheduleStudentListPreferences);
        } else {
            return this.getUserPreferences(0, '/OneSISScheduleStudentList').pipe(
                map(json => {
                    let preferences = JSON.parse(json[0]) as ScheduleStudentListPreferences;
                    preferences = System.convert(preferences, new ScheduleStudentListPreferences());
                    return preferences;
                })
            );
        }
    }

    getClassesByCoursePreferences() {
        if (this.classesByCoursePreferences) {
            return of(this.classesByCoursePreferences);
        } else {
            return this.getUserPreferences(0, '/OneSISClassesByCourse').pipe(
                map(json => {
                    const preferences = JSON.parse(json[0]) as ClassesByCoursePreferences;
                    this.classesByCoursePreferences = preferences;
                    return preferences;
                })
            );
        }
    }

    getClassRosterPreferences() {
        if (this.classRosterPreferences) {
            return of(this.classRosterPreferences);
        } else {
            return this.getUserPreferences(0, '/OneSISClassRoster').pipe(
                map(json => {
                    const preferences = JSON.parse(json[0]) as ClassRosterPreferences;
                    this.classRosterPreferences = preferences;
                    return preferences;
                })
            );
        }
    }

    getRoomSchedulingSettingsPreferences() {
        if (this.roomSchedulingSettingsPreferences) {
            return of(this.roomSchedulingSettingsPreferences);
        } else {
            return this.getUserPreferences(0, '/OneSISRoomSchedulingSettings').pipe(
                map(json => {
                    const preferences = JSON.parse(json[0]) as RoomSchedulingSettingsPreferences;
                    this.roomSchedulingSettingsPreferences = preferences;
                    return preferences;
                })
            );
        }
    }

    updateFavoritePortals(staffAssignedPortals: Portal[], isDefaultPreferences: boolean) {
        let paramString = '';
        paramString += '?isDefaultPreferences=' + isDefaultPreferences;
        return this.http.post<any>(System.apiURL.Student + 'UpdateFavoritePortals' + paramString, staffAssignedPortals);
    }
}
